{
  "version": 1,
  "asset_id": "4eb91709-dd2b-4bb7-ba90-3e32425ee1b9",
  "project_id": "29ba6777-831c-40d4-9b2c-b7cd5071baf3",
  "url": "/__l5e/assets-v1/4eb91709-dd2b-4bb7-ba90-3e32425ee1b9/quantum-mind-brain.png",
  "r2_key": "a/v1/29ba6777-831c-40d4-9b2c-b7cd5071baf3/4eb91709-dd2b-4bb7-ba90-3e32425ee1b9/quantum-mind-brain.png",
  "original_filename": "quantum-mind-brain.png",
  "size": 1177608,
  "content_type": "image/png",
  "created_at": "2026-07-29T19:16:22Z"
}
